/* eslint-disable no-useless-catch */
/* eslint-disable object-shorthand */
/* eslint-disable no-plusplus */
/* eslint-disable no-var */
/* eslint-disable prefer-const */
/* eslint-disable vars-on-top */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-named-as-default-member */
import React, { createContext, useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import {useHistory} from "react-router-dom";
import { usePopupManager } from '../PopupManager/PopupManager';
import { logoutAndClearData, getISTTime,handleLogout, azureLoginPage } from '../../utils/utils';
import { setLogin } from '../../redux/features/auth/actions';
import WarningModal from '../../components/WarningModal/WarningModal';
import apiService from '../../apis/apiService';
import Cvloader from '../../components/CvLoader/Cvloader';
import { MESSAGE_TYPE } from '../../constants';

export const AuthorizationContext = createContext(null);

const AuthorizationHandler = props => {
  const auth = useSelector((state) => state.auth);
  const [isWarningOpen, setIsWarningOpen] = useState(false)
  const [user, setUser] = useState({ isLoaded: false });
  const [keycloak, setKeycloak] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(true); // false
  const [authPolicies, setAuthPolicies] = useState([]);
  const [authResources, setAuthResources] = useState([]);
  const [authToken, setAuthToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({
    session_id: '',
    access_token: '',
    refresh_token: ''
  })
  const history = useHistory();
  const dispatch = useDispatch();
  const showPopup = usePopupManager()


  const logoutUser = () => {
    logoutAndClearData(keycloak);
    setIsAuthenticated(false);
    setAuthToken(null);
    setUser(null);
  };
  useEffect(() => {
    setUser(auth)
  });

  const authData = {
    user,
    isAuthenticated,
    logoutUser,
    authPolicies,
    authResources,
    authToken,
  };
  const handleConcurrentLogin = async () => {
    try {
      await apiService.handleConcurrentLogin(userData, dispatch).then(() => {
        history.push('/home');
      })
    } catch (error) {
      console.error(error)
    }
  }

  const callbackFromAzure = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (!code) {
      console.error('Code parameter is missing from the URL.');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}home/api/auth/azure/callback/?code=${code}`,{credentials:'include'});
      const data = await response.json();  
      sessionStorage.setItem("isAuthenticated", "true");    
      dispatch(setLogin({
        isAuthenticated: true,
        authPolicies: [],
        sessionId: data.session_id,
        recentStatus : response.status,
        loginStatus:data?.login_status
      }));
      if (response.status === 409) {
        setIsWarningOpen(true);
        setLoading(false);
      }
    } catch (error) {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: MESSAGE_TYPE.FAILURE,
        info: error?.message || " Something went wrong!. Please try again later",
        })
      console.error('Error:', error)    
      setLoading(false)
    } finally {     
      setLoading(false);
    }
  };
  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("isAuthenticated");
  
    if (isLoggedIn) {
      setLoading(false);
      return;
    }
  
    callbackFromAzure();
  }, []);
  if (isWarningOpen) {
    return (
      <WarningModal
        open={isWarningOpen}
        handleClose={() => {
          handleLogout().then(()=>{
            sessionStorage.clear()  
            azureLoginPage()
          }).catch(()=>{
            sessionStorage.clear()  
            azureLoginPage()
          });
          sessionStorage.clear()        
          setIsWarningOpen(false)
        }}
        confirmDelete={() => {
          handleConcurrentLogin()
          setIsWarningOpen(false)
        }}
        msg="User already logged in, Are you sure you want continue?"
        popUpHeading="&nbsp;Login"
      />
    )
  }
  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: '20%' }}>
    <Cvloader />
   </div> 
  }
  return <AuthorizationContext.Provider value={authData} {...props} />;
};

export const useAuthorizationContext = () => useContext(AuthorizationContext);

export default AuthorizationHandler;
